import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';

import { AccessoryComponent } from './component/accessory/accessory.component';
import { AccessoryLocalComponent } from './component/accessory-local/accessory-local.component';
import { AccessoryControlComponent } from './component/accessory-control/accessory-control.component';
import { AccessoryStatusService } from './service/accessory-status.service';
import { AccessoryCreateComponent } from './component/accessory-create/accessory-create.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MaterializeModule,
    ReactiveFormsModule
  ],
  exports: [
    AccessoryComponent,
    AccessoryLocalComponent,
    AccessoryControlComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AccessoryComponent,
    AccessoryLocalComponent,
    AccessoryControlComponent,
    AccessoryCreateComponent
  ],
  providers: [
    AccessoryStatusService
  ]
})
export class AccessoryModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/accessory/accessory.module.ts